import React from 'react';
import PropTypes from 'prop-types';

const CIDList = ({ cids }) => {
  return (
    <>
      {cids.length === 0 ? (
        <p className="text-center text-gray-600">Nenhum resultado encontrado</p>
      ) : (
        cids.map((cid, index) => (
          <div
            key={cid.id || index} // Usando o `codigo` como chave ou o índice como fallback
            className="bg-white p-4 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
          >
            <h3 className="text-lg font-semibold text-gray-800">
              {cid.id ? cid.id : 'Sem Código'}{' '}
              {/* Verifique se o código existe */}
            </h3>
            <p className="text-sm text-gray-600">
              {cid.name ? cid.name : 'Sem Nome'}{' '}
              {/* Verifique se o nome existe */}
            </p>
          </div>
        ))
      )}
    </>
  );
};

CIDList.propTypes = {
  cids: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
};

export default CIDList;
